const css = require('./registration.css');
const { Text } = require('account-ui');
const { inputText, blurText } = require('../../../signals/form');
const Error = require('../error');
const ToS = require('../tos');
const UserSharedDataForm = require('../../common/user/user-shared-data-form');
const LegalEntityForm = require('../../common/user/legal-entity-form');
const SoleProprietorForm = require('../../common/user/sole-proprietor-form');
const IndividualForm = require('../../common/user/individual-form');

const { cut } = require('../../../helpers/utils');
const signals = require('../../../signals/auth/registration');
const SCHEMES = require('../../../helpers/scheme');
const SUBMIT = cut(css.submit);
let { redirect } = require('../../../signals/utils');

class Registration {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            click: {
                [SUBMIT]: this.handleNext,
                [cut(css.redirect)]: this.redirect
            }
        };
    }

    handleNext () {
        this.$context.signal(signals.showToS);
    }

    redirect (e) {
        e.stopPropagation();
        let url = e.currentTarget.getAttribute('cat-url');
        this.$context.signal(redirect, { url: url });
    }
}

module.exports = {
    constructor: Registration,
    children: [
        {
            name: 'tos',
            component: ToS,
            props: {
                signals: {
                    accept: signals.registration,
                    cancel: signals.cancelToS
                }
            }
        },
        {
            name: 'error',
            component: Error,
            props: {
                text: 'Что-то пошло не так. Пожалуйста, нажмите кнопку еще раз.'
            },
            watcher: {
                isError: ['auth', 'isError']
            }
        },
        {
            name: 'error-country',
            component: Error,
            props: {
                text: 'Выберите страну'
            },
            watcher: {
                isError: ['auth', 'isCountryError']
            }
        },
        {
            name: 'text-email',
            component: Text,
            props: {
                signals: { inputText, blurText },
                position: 'leftToRight',
                scheme: SCHEMES.email
            },
            watcher: {
                value: ['registration', 'form', 'email'],
                error: ['registration', 'error', 'email']
            }
        },
        {
            name: 'text-password',
            component: Text,
            props: {
                signals: { inputText, blurText },
                scheme: SCHEMES.password,
                position: 'leftToRight',
                type: 'password'
            },
            watcher: {
                value: ['registration', 'form', 'password'],
                error: ['registration', 'error', 'password']
            }
        },
        {
            name: 'text-repeat-password',
            component: Text,
            props: {
                signals: { inputText, blurText },
                scheme: SCHEMES.repeatPassword,
                position: 'leftToRight',
                type: 'password'
            },
            watcher: {
                value: ['registration', 'form', 'repeatPassword'],
                error: ['registration', 'computed', 'error', 'repeatPassword']
            }
        },
        {
            name: 'user-shared-data-form',
            component: UserSharedDataForm(['registration'], signals.selectUserType, signals.selectCountry),
            props: {
                formPath: 'registration',
                hideEmail: true
            },
            watcher: {
                isUserTypeSelectEnabled: ['registration', 'computed', 'isUserTypeSelectEnabled']
            }
        },
        {
            name: 'legal-entity-form',
            component: LegalEntityForm(['registration']),
            props: {
                formPath: 'registration'
            },
            watcher: {
                userCountryId: ['registration', 'form', 'countryId']
            }
        },
        {
            name: 'sole-proprietor-form',
            component: SoleProprietorForm(['registration']),
            props: {
                formPath: 'registration'
            },
            watcher: {
                userCountryId: ['registration', 'form', 'countryId']
            }
        },
        {
            name: 'individual-form',
            component: IndividualForm(['registration']),
            props: {
                formPath: 'registration'
            },
            watcher: {
                userCountryId: ['registration', 'form', 'countryId']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/auth/registration/index.js